var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { log } from '../../lib/logger';
import { createAuth, } from '@spotify-internal/oauth-silent-authentication';
import { isTst1 } from '../../lib/environment';
import { showChatBoxParamName } from '../../constants/locationParams';
export const noopTokenProvider = {
    gotoLoginWindow() {
        log.error('This path should never run');
    },
    getNewToken() {
        return __awaiter(this, void 0, void 0, function* () {
            throw { error: 'login_required' };
        });
    },
};
class OauthSilentAuthentication {
    constructor(clientId, scopes) {
        this.clientId = clientId;
        this.scopes = scopes;
        this.authClient = createAuth({ clientId, scopes }, isTst1 ? { url: 'https://accounts-shared.spotify.net' } : undefined);
    }
    gotoLoginWindow(redirectUri) {
        this.authClient.login({
            redirectUri,
            state: showChatBoxParamName,
        });
    }
    getNewToken() {
        return __awaiter(this, void 0, void 0, function* () {
            const [token] = yield this.authClient.tokenProvider();
            return token;
        });
    }
}
let tokenProviderFactory = (clientId, scopes) => new OauthSilentAuthentication(clientId, scopes);
export const mockTokenProvider = () => {
    tokenProviderFactory = () => noopTokenProvider;
};
const tokenProviderCache = {};
const getKey = (clientId, scopes) => [clientId, ...scopes].join('##');
export const getTokenProvider = (clientId, scopes) => {
    const key = getKey(clientId, scopes);
    if (!(key in tokenProviderCache)) {
        tokenProviderCache[key] = tokenProviderFactory(clientId, scopes);
    }
    return tokenProviderCache[key];
};
